module.exports = __webpack_public_path__ + "static/media/step-3.716dde5a.gif";